import { createSelector } from "reselect";
import { ASSIGNMENT_STATUS } from "shared/constants";
import { isWindowEvent, getPersonnelRolesMapper } from "shared/helpers";
import moment from "moment";
import orderBy from "lodash/orderBy";

const getUserAssignments = (state) => state.userDashboard.assignments;
const getTerms = (state) => state.userDashboard.terms;
const getRoles = (state) => getPersonnelRolesMapper(state.statics.roles);

export const getMappedAssignments = createSelector(
  [getUserAssignments, getRoles],
  (assignments, roles) =>
    assignments.filter((assignment) => {
      if (assignment.status.toUpperCase() === ASSIGNMENT_STATUS.closed)
        return false;

      const currentDate = moment(assignment.serverDateTime).format(
        "YYYY-MM-DD"
      );
      const assignmentDate =
        assignment.rescheduleDate ||
        (isWindowEvent(assignment)
          ? assignment.endTestDate
          : assignment.testDate);
      return moment(assignmentDate)
        .add(assignment.role.role === roles.TEST_DAY_COORDINATOR ? 7 : 1, "d")
        .isSameOrAfter(currentDate);
    })
);

export const orderTerms = createSelector([getTerms], (terms) => {
  const orderedTerms = orderBy(terms, ["cycleId", "type"], ["asc", "desc"]);

  return orderedTerms || [];
});
